module.exports = __webpack_public_path__ + "static/media/Ufo_RewardBackground.09f6b34d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/themedEvent/reward-background/Ufo_RewardBackground.png
// module id = 1362
// module chunks = 3